import React from 'react';
import { Checkbox, Label } from 'flowbite-react';
interface Props {
	styleing: string;
	agreed: boolean;
	setHasAgreed: (e: boolean) => void;
}

export const AgreedCheckbox = ({ styleing, agreed, setHasAgreed }: Props) => {
	return (
		<div className={`flex items-center gap-2 ${styleing}`}>
			<Checkbox
				id="agree"
				color={'blue'}
				checked={agreed}
				className="mt-[3px] cursor-pointer"
				onChange={e => setHasAgreed(e.target.checked)}
			/>
			<Label htmlFor="agree" className="dark:text-[#FFFFFF]">
				By scheduling this Technical Round, I agree to attend as planned and value the interviewer's time.
			</Label>
		</div>
	);
};
